module.exports = __webpack_public_path__ + "static/assets/a03c585f6a1404e9d6848a6b66f857b3.svg";